import { render, staticRenderFns } from "./products-results-edit.vue?vue&type=template&id=33489640&"
import script from "./products-results-edit.vue?vue&type=script&lang=js&"
export * from "./products-results-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports